import { AudienciaAviso, TipoAviso } from '../../../../types/aviso';

export interface AvisoFormValues {
  titulo: string;
  mensagem: string;
  tipo: TipoAviso | '';
  dataInicio: string; // yyyy-MM-dd
  dataExpiracao: string; // yyyy-MM-dd
  audiencia: AudienciaAviso;
  destinatariosIds: string[];
}

export type AvisoFormErrors = Partial<Record<keyof AvisoFormValues, string>>;

export const validateAvisoForm = (values: AvisoFormValues): AvisoFormErrors => {
  const errors: AvisoFormErrors = {};

  if (!values.titulo?.trim()) {
    errors.titulo = 'Título é obrigatório';
  } else if (values.titulo.trim().length > 120) {
    errors.titulo = 'Máximo 120 caracteres';
  }

  if (!values.mensagem?.trim()) {
    errors.mensagem = 'Mensagem é obrigatória';
  } else if (values.mensagem.trim().length > 2000) {
    errors.mensagem = 'Máximo 2000 caracteres';
  }

  if (!values.tipo) {
    errors.tipo = 'Tipo é obrigatório';
  } else if (
    values.tipo !== TipoAviso.GERAL &&
    values.tipo !== TipoAviso.FINANCEIRO
  ) {
    errors.tipo = 'Tipo inválido';
  }

  if (!values.dataInicio) {
    errors.dataInicio = 'Data de início é obrigatória';
  }

  if (!values.dataExpiracao) {
    errors.dataExpiracao = 'Data de expiração é obrigatória';
  }

  if (
    values.dataInicio &&
    values.dataExpiracao &&
    !errors.dataInicio &&
    !errors.dataExpiracao
  ) {
    if (values.dataExpiracao < values.dataInicio) {
      errors.dataExpiracao =
        'Data de expiração não pode ser menor que data de início';
    }
  }

  if (
    values.audiencia === AudienciaAviso.ESPECIFICOS &&
    (!values.destinatariosIds || values.destinatariosIds.length === 0)
  ) {
    errors.destinatariosIds =
      'Selecione ao menos um cliente quando a audiência for específica';
  }

  return errors;
};

export const hasErrors = (errors: AvisoFormErrors): boolean =>
  Object.keys(errors).length > 0;
